import React from 'react';
import { connect } from 'react-redux';

import {
    Backdrop,
    CircularProgress,
} from "@material-ui/core";

import {
    currentLanguage,
} from "src/shared_modules/i18n";

class StaticContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading : true,
        }
    }

    componentDidMount() {
        this.loadingFinished = this.loadingFinished.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if( prevProps.currentLang !== this.props.currentLang || prevProps.url !== this.props.url ) {
            this.setState({isLoading: true});

        }
    }

    loadingFinished() {
        this.setState({isLoading: false});
    }

    render() {
        if( !this.props.url )
            return(null);

        const code2 = currentLanguage().code2;
        const path = "/visitor/html/"+ code2 + "/" + this.props.url;

        let cssIFrame = "content";
        if( this.state.isLoading ) {
            cssIFrame += " loading";
        }
        return (<React.Fragment>
                     { this.state.isLoading && <Backdrop className="inside-container" open={true} invisible={true}>
                        <CircularProgress />
                    </Backdrop> }
                    <iframe title="staticcontent"
                            className={cssIFrame}
                            src={path}
                            onLoad={ ()=>{this.loadingFinished()} }
                        />
            </React.Fragment>);
    }
}

/*
 * ---------------------------------------------------------------------
 * StaticContent Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        currentLang: state.system.currentLang,
    };
};
/*
* ---------------------------------------------------------------------
* Export the redux container
* ---------------------------------------------------------------------
*/
export default connect(
       mapStateToProps,
   )(StaticContent);
